var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "What We Do",
      "tabActive": "Safety Management",
      "bg": "/images/sub/visual/sv4.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('div', {
    staticClass: "page-tit-wrap"
  }, [_c('h2', {
    staticClass: "page-tit"
  }, [_vm._v(" Safety Management ")]), _c('p', [_vm._v(" 작업자 안전을 위한 산업 보건 및 안전 관리 경영시스템을 구축했으며, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" ISO 45001 : 2018 안전보건 경영시스템 취득 및 사내 산업안전보건 시스템 최신화 ")])])])], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "안전 관리 시스템"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto mb-90 mb-md-120 mb-lg-140 d-none d-lg-block",
    attrs: {
      "src": "/images/sub/wwd/management/management-img.png",
      "max-width": "950"
    }
  }), _c('v-img', {
    staticClass: "mx-auto mb-90 mb-md-120 mb-lg-140 d-block d-lg-none",
    attrs: {
      "src": "/images/sub/wwd/management/management-img-mo.png",
      "max-width": "480"
    }
  }), _c('v-row', {
    staticClass: "my-n10 my-lg-n40"
  }, [_c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/management/management-icon1.png",
      "iconWidth": "50",
      "tit": "안전보건 관리 체계 구축 및 유지"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c"
  }, [_vm._v(" 기업의 안전보건 조직 및 재해현황, 업종, 규모, 공정 특성에 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 따른 매뉴얼 숙지 및 안전보건관리체계 구축에 따른 파악 및 이행 ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/management/management-icon2.png",
      "iconWidth": "53",
      "tit": "자율적 산업 재해 예방"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c"
  }, [_vm._v(" 근로자가 안전보건에 관한 의견 제시 현장의 위험요인 파악, 개선계획 수립, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 근로자 제안 운영 등 참여 여부 확인 ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/management/management-icon3.png",
      "iconWidth": "51",
      "tit": "안전보건 교육훈련"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c"
  }, [_vm._v(" 근로자의 안전을 위한 안전보건관리 체계 교육 현장의 위험요인 파악을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 위한 항목들을 파악 조치 운선순위 결정, 통제 및 제어방안 수립 ")])]), _c('sub-icon-box', {
    attrs: {
      "icon": "/images/sub/wwd/management/management-icon4.png",
      "iconWidth": "54",
      "tit": "안전보건 관련 법규 요구 사항 준수"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-2c"
  }, [_vm._v(" 중대재해 처벌법 및 안전보건관리체계 구축 목적, 핵심요소, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 이행 필요성에 따른 핵심 요소별 업무절차 수립 및 이행 ")])])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }